module.exports = __WEBPACK_EXTERNAL_MODULE_1295__;


//////////////////
// WEBPACK FOOTER
// external "History"
// module id = 1295
// module chunks = 1